import styled from 'styled-components';
import MUIDivider from '@material-ui/core/Divider';

const Divider = styled(MUIDivider)`
  background-color: #f0f4f7;
  background-color: ${({ theme }) => theme.colors.dropShadowV2};
`;

export default Divider;
